import { Box, Grid, TextField, Typography } from "@mui/material"
import styleCss from "../Style/style"
import LiveChat from "../img/convert-icon.png"
import SupportImg from "../img/air-icon.png"
import SendIcon from "../img/senticon.png"
import { Link } from "react-router-dom"
import Recivedimg from "../img/recevedicon.png"
import Recivedimg1 from "../img/sendericon.png"
import Instant from "../img/timeiconnew1.png"

const LiveChart = () => {
    return (
        <>
            <Grid container spacing={2}>
                <Grid size={{ md: 8, xs:12}}>
                    <Box
                        sx={{
                            bgcolor: " #fff",
                            borderRadius: "30px",
                            display: "block",
                            padding: '20px',
                            overflow: 'hidden',
                            "@media (max-width:600px)": {
                                padding: '25px 8px',
                            },
                        }}
                    >
                        <Typography sx={{
                            fontFamily: '"Segoe UI", sans-serif',
                            fontSize: '17px',
                            fontWeight: 600,
                            textAlign: 'left',
                            color: '#0e182b',
                        }}>
                            <img src={LiveChat} style={{ verticalAlign: 'middle' }} />  Live Chat Support
                        </Typography>

                        <Box sx={{ border: '1px solid #ddd', marginTop: '25px', borderRadius: '10px' }}>
                            <Box sx={{
                                padding: '10px',
                                backgroundColor: '#f9fafb',
                                borderTopRightRadius: '9px',
                                borderTopLeftRadius: '9px',
                                borderBottom: 'solid 1px #dedede',
                            }}>
                                <Grid sx={{ display: 'flex' }}>
                                    <Grid sx={{ marginRight: '10px' }}>
                                        <img src={SupportImg} style={{ verticalAlign: 'middle' }} />
                                    </Grid>
                                    <Grid>
                                        <Typography sx={{
                                            fontFamily: '"Segoe UI", sans-serif',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            textAlign: 'left',
                                            color: '#030213',
                                        }}>
                                            Support Agent
                                        </Typography>
                                        <Typography sx={{
                                            fontFamily: 'Segoe UI',
                                            fontSize: '13px',
                                            fontWeight: 'normal',
                                            textAlign: 'left',
                                            color: '#717182',
                                        }}>
                                            Usually responds within minutes
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box sx={{ padding: '20px 5px 20px 15px', height: '345px', overflowY: 'scroll', overflowX: 'hidden' }}>
                                {/* recived */}
                                <Grid sx={{ display: 'flex', marginBottom: '15px' }}>
                                    <Grid sx={{ marginRight: '15px' }}>
                                        <img src={Recivedimg} />
                                    </Grid>
                                    <Grid sx={styleCss.MessageRecivesd}>
                                        <Typography sx={styleCss.TodayText}>
                                            Hello! How can I help you today?
                                        </Typography>
                                        <Typography sx={styleCss.Timedate}>
                                            10:30 AM
                                        </Typography>
                                    </Grid>
                                </Grid>
                                {/* end */}
                                {/* sender */}
                                <Grid sx={{ display: 'flex', justifyContent: 'end', marginBottom: '15px' }}>
                                    <Grid sx={styleCss.MessageSender}>
                                        <Typography sx={styleCss.TodayText1}>
                                            I want to track my bus
                                        </Typography>
                                        <Typography sx={styleCss.Timedate1}>
                                            10:30 AM
                                        </Typography>
                                    </Grid>
                                    <Grid sx={{ marginLeft: '15px' }}>
                                        <img src={Recivedimg1} />
                                    </Grid>
                                </Grid>
                                {/* end */}
                                {/* recived */}
                                <Grid sx={{ display: 'flex', marginBottom: '15px' }}>
                                    <Grid sx={{ marginRight: '15px' }}>
                                        <img src={Recivedimg} />
                                    </Grid>
                                    <Grid sx={styleCss.MessageRecivesd}>
                                        <Typography sx={styleCss.TodayText}>
                                            Hello! How can I help you today?
                                        </Typography>
                                        <Typography sx={styleCss.Timedate}>
                                            10:30 AM
                                        </Typography>
                                    </Grid>
                                </Grid>
                                {/* end */}
                                {/* recived */}
                                <Grid sx={{ display: 'flex', marginBottom: '15px' }}>
                                    <Grid sx={{ marginRight: '15px' }}>
                                        <img src={Recivedimg} />
                                    </Grid>
                                    <Grid sx={styleCss.MessageRecivesd}>
                                        <Typography sx={styleCss.TodayText}>
                                            Hello! How can I help you today?
                                        </Typography>
                                        <Typography sx={styleCss.Timedate}>
                                            10:30 AM
                                        </Typography>
                                    </Grid>
                                </Grid>
                                {/* end */}
                                {/* sender */}
                                <Grid sx={{ display: 'flex', justifyContent: 'end', marginBottom: '15px' }}>
                                    <Grid sx={styleCss.MessageSender}>
                                        <Typography sx={styleCss.TodayText1}>
                                            I want to track my bus
                                        </Typography>
                                        <Typography sx={styleCss.Timedate1}>
                                            10:30 AM
                                        </Typography>
                                    </Grid>
                                    <Grid sx={{ marginLeft: '15px' }}>
                                        <img src={Recivedimg1} />
                                    </Grid>
                                </Grid>
                                {/* end */}
                            </Box>
                            <Box sx={{
                                padding: '15px',
                                backgroundColor: '#fff',
                                borderBottomRightRadius: '9px',
                                borderBottomLeftRadius: '9px',
                                borderTop: 'solid 1px #dedede',
                            }}>
                                <Grid position={{ position: 'relative' }}>
                                    <TextField
                                        variant="outlined"
                                        placeholder="Type your message..."
                                        fullWidth
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                fontFamily: '"Segoe UI", sans-serif',
                                                fontSize: '14px',
                                                fontWeight: 'normal',
                                                color: '#030213',
                                                backgroundColor: '#f9fafb',
                                                padding: '0px',
                                                '& fieldset': {
                                                    borderColor: '#dedede',
                                                },
                                                '&:hover fieldset': {
                                                    borderColor: '#bdbdbd',
                                                },
                                                '&.Mui-focused fieldset': {
                                                    borderColor: 'transparent',
                                                },
                                            },
                                            '& .MuiInputBase-input': {
                                                padding: '10px 50px 10px 10px',
                                                fontFamily: '"Segoe UI", sans-serif',
                                                fontSize: '14px',
                                                color: '#030213',
                                            },
                                            '& .MuiInputLabel-root': {
                                                fontFamily: '"Segoe UI", sans-serif',
                                                fontSize: '13px',
                                                color: '#717182',
                                            },
                                        }}
                                    />
                                    <Link to={'/'}> <img src={SendIcon} style={{
                                        position: 'absolute', right: '2px', bottom: '0',
                                        top: '0px', margin: 'auto',
                                    }} /></Link>
                                </Grid>
                            </Box>
                        </Box>
                    </Box>
                </Grid>
                <Grid size={{ md: 4, xs: 12}}>
                    <Box
                        sx={{
                            bgcolor: " #fff",
                            borderRadius: "30px",
                            display: "block",
                            padding: '20px',
                            marginBottom: '30px',
                            "@media (max-width:600px)": {
                                padding: '25px 8px',
                            },
                        }}
                    >
                        <Typography sx={{
                            fontFamily: '"Segoe UI", sans-serif',
                            fontSize: '17px',
                            fontWeight: 600,
                            textAlign: 'left',
                            color: '#0e182b',
                            marginBottom: '22px',
                        }}>
                            Your Complaints
                        </Typography>
                        <Box sx={{
                            padding: '15px',
                            borderRadius: '12px',
                            border: '1px solid #e5e5e5',
                            backgroundColor: '#fff',
                            marginBottom: '15px',
                        }}>
                            <Typography sx={{
                                fontFamily: '"Segoe UI", sans-serif',
                                fontSize: 16,
                                fontWeight: 400,
                                textAlign: 'left',
                                color: '#0e182b',
                                marginBottom: '10px',
                            }}>
                                Chat Features
                            </Typography>
                            <Typography sx={{
                                fontFamily: '"Segoe UI", sans-serif',
                                fontSize: 14,
                                fontWeight: 400,
                                textAlign: 'left',
                                color: '#717182',
                                marginBottom: '10px',
                            }}>
                                <img src={Instant} style={{ marginRight: '5px', verticalAlign: 'middle' }} />
                                Instant responses
                            </Typography>
                            <Typography sx={{
                                fontFamily: '"Segoe UI", sans-serif',
                                fontSize: 14,
                                fontWeight: 400,
                                textAlign: 'left',
                                color: '#717182',
                                marginBottom: '10px',
                            }}>
                                <img src={Instant} style={{ marginRight: '5px', verticalAlign: 'middle' }} />
                                File sharing support
                            </Typography>
                            <Typography sx={{
                                fontFamily: '"Segoe UI", sans-serif',
                                fontSize: 14,
                                fontWeight: 400,
                                textAlign: 'left',
                                color: '#717182',
                                marginBottom: '10px',
                            }}>
                                <img src={Instant} style={{ marginRight: '5px', verticalAlign: 'middle' }} />
                                Screen sharing available
                            </Typography>
                            <Typography sx={{
                                fontFamily: '"Segoe UI", sans-serif',
                                fontSize: 14,
                                fontWeight: 400,
                                textAlign: 'left',
                                color: '#717182',
                                marginBottom: '10px',
                            }}>
                                <img src={Instant} style={{ marginRight: '5px', verticalAlign: 'middle' }} />
                                Chat history saved
                            </Typography>
                        </Box>
                        <Box sx={{
                            padding: '15px',
                            borderRadius: '12px',
                            border: '1px solid #e5e5e5',
                            backgroundColor: '#fff',
                            marginBottom: '15px',
                        }}>
                            <Typography sx={{
                                fontFamily: '"Segoe UI", sans-serif',
                                fontSize: 16,
                                fontWeight: 400,
                                textAlign: 'left',
                                color: '#0e182b',
                                marginBottom: '15px',
                            }}>
                                Quick Links
                            </Typography>
                            <Link style={styleCss.QuickLinks}>
                                Track My Booking
                            </Link>
                            <Link style={styleCss.QuickLinks}>
                                Cancellation Policy
                            </Link>
                            <Link style={styleCss.QuickLinks}>
                                Payment Issues
                            </Link>
                            <Link style={styleCss.QuickLinks}>
                                Bus Delays
                            </Link>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </>
    )
}
export default LiveChart